import { getLoginSession } from '../utils/common';

export const useAuth = () => {
    const [{ exp }, { sessionToken }, { token }] = getLoginSession();
    if (exp < + new Date() || !sessionToken) return false;
    return true;
}